import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-another-user-login',
  templateUrl: './another-user-login.component.html',
  styleUrls: ['./another-user-login.component.scss'],
  standalone: false
})
export class AnotherUserLoginComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<AnotherUserLoginComponent>>(MatDialogRef);
  data = inject<{
    currentLogin: string;
  }>(MAT_DIALOG_DATA);


  constructor() { }

  ngOnInit(): void {
  }

  onLogoutBtnClick(): void {
    this.dialogRef.close(true);
  }
}
